import Box from '@mui/material/Box';

const logoSrc = `${import.meta.env.BASE_URL}branding/sentinel-logo.png`;

// ==============================|| LOGO ICON ||============================== //

export default function LogoIcon() {
  return (
    <Box
      sx={{
        width: 64,
        height: 48,
        overflow: 'hidden',
        borderRadius: 1,
        flexShrink: 0
      }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt="BFT Sentinel"
        sx={{
          display: 'block',
          width: 168,
          height: 48,
          objectFit: 'cover',
          objectPosition: 'left center',
          maxWidth: 'none'
        }}
      />
    </Box>
  );
}
